/**
 * 自定义
 * {Object} myEditor graph对象
 */
window.myEditor = null;
window.cells = null;
// eslint-disable-next-line no-var
window.IMC = window.IMC || {};

window.IMC.urlPattern = '/api/v1/graph/file';
// 对应的权限。ROOT全文件夹
window.IMC.userPath = 'ROOT';
// 对应的权限。Test1 子文件夹
// IMC.userPath = "Test1"

window.env = process.env.NODE_ENV;
window.isDevelopment = window.env === 'development';
